import $ from 'jquery';
import 'magnific-popup'
import 'magnific-popup/dist/magnific-popup.css'
import AutoNumeric from 'autonumeric';
window.jQuery = window.$ = $;
